/** The amount of time to wait while the user is typing before we search the backend API. */
const SEARCH_DEBOUNCE_MILLIS = 301

/** The amount of time to wait while the user selecting a date before we search the backend API. */
const DATE_DEBOUNCE_MILLIS = 1003

/** The minimum number of search characters to have before making an API call. */
const MIN_SEARCH_CHARS = 3

/** The point at which a scroll is considered to be at the bottom of the list/container. Load more content if within this range. */
const SCROLL_BOTTOM_OUT = 100

module.exports = {
    SEARCH_DEBOUNCE_MILLIS,
    DATE_DEBOUNCE_MILLIS,
    MIN_SEARCH_CHARS,
    SCROLL_BOTTOM_OUT
}
